<template>
  <div id="app">
    <router-view />
  </div>
</template>

<style lang="scss">
@import "./assets/sass/app.scss";
</style>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  async created() {
    await this.listenToPostMessage();
  },
  computed: {
    ...mapGetters({
      state: "getState"
    })
  },
  methods: {
    ...mapActions({
      setState: "setState"
    }),
    listenToPostMessage() {
      window.addEventListener("message", event => {
        const eventData = event.data;

        if (eventData.salt !== process.env.VUE_APP_EVENT_SALT) return;

        if (eventData.event === "updateState") {
          this.setState(eventData.data);
        }
      });
    }
  }
};
</script>
